import { useMemo, useState } from 'react';

import { ChakraFlex } from '@equip.health/ui';
import DischargePlanView from './dischargeplan/DischargePlanView';
import CarePlanningSubTabHeader, {
  CarePlanningTab,
  CarePlanningTabValue,
  CarePlanningSubTabProps,
} from './CarePlanningSubTabHeader';
import { CarePlanView } from '~/components/maud/patients/profile/tabs/careplan/CarePlanView';

const CarePlanningSubTabs = ({
  patientId,
  detailsTabId,
}: {
  patientId: string;
  detailsTabId?: string;
}) => {
  const [selectedSubTab, setSelectedSubTab] = useState<CarePlanningTabValue>(() =>
    detailsTabId === CarePlanningTab.DISCHARGE_PLAN
      ? CarePlanningTab.DISCHARGE_PLAN
      : CarePlanningTab.CARE_PLAN,
  );

  const carePlanningTabs = useMemo<CarePlanningSubTabProps[]>(
    () => [
      {
        title: 'Care plan',
        value: CarePlanningTab.CARE_PLAN,
      },
      {
        title: 'Discharge plan',
        value: CarePlanningTab.DISCHARGE_PLAN,
      },
    ],
    [],
  );

  return (
    <ChakraFlex direction="column" width="100%">
      <ChakraFlex justify="flex-start">
        <CarePlanningSubTabHeader
          onTabChange={setSelectedSubTab}
          selectedTab={selectedSubTab}
          tabs={carePlanningTabs}
        />
      </ChakraFlex>
      {selectedSubTab !== CarePlanningTab.CARE_PLAN ? (
        <DischargePlanView patientId={patientId} />
      ) : (
        <CarePlanView patientId={patientId} />
      )}
    </ChakraFlex>
  );
};

export default CarePlanningSubTabs;
